import { setCookie } from 'cookies-next';

/**
 * accessToken, refreshToken을 Cookie에 저장합니다.
 * @param accessToken
 * @param refreshToken
 */
export default function setTokens(accessToken: string, refreshToken?: string) {
  setCookie('accessToken', accessToken);
  if (refreshToken) {
    setCookie('refreshToken', refreshToken);
  }
}
